import React from 'react';

// Components
import MetaDescription from '../../../components/Molecules/MetaDescription';
import HighScoreScreen from '../../../components/modules/Yamb/Organisms/HighScoreScreen';

// Layouts
import SectionWrapper from '../../../Layouts/SectionWrapper';

function HallOfFame() {
	return (
		<>
			<MetaDescription
				page={{
					meta: {
						pageTitle: 'High score - Yamb',
						metaDescription: 'Online multiplayer Yamb (Yahtzee) game high scores',
					},
				}}
			/>
			<SectionWrapper
				title={null}
			>
				<HighScoreScreen type="weekly" />
			</SectionWrapper>
		</>
	);
}

export default HallOfFame;
